import { gql } from "@apollo/client";

export default gql`
  mutation savePersonCareerCriteria(
    $organizationId: Int!
    $userId: Int!
    $criteria: [UserCareerCriteriaInput!]!
    $deleteIds: [Int!]
  ) {
    saveUserCareerCriteria(
      organizationId: $organizationId
      userId: $userId
      criteria: $criteria
      deleteIds: $deleteIds
    ) {
      criteria {
        id
        content
        ordinal
      }
      createdIds {
        clientId
        id
        kind
      }
    }
  }
`;
